/**
 * time-formatter-service AMD module that returns timeFormatterService implementation.
 *
 * @summary Time formatting service.
 * @version 0.1
 * @since 0.1
 * @author Yuliy Lysyak <yuliy.lysyak@aofl.com>
 * @author Sergii Kshenskyi <sergii.kshenskyi@aofl.com>
 * @requires module:js/fecha/1-2-2/fecha
 * @module js/legacy-aofl-js/0-6-0/time-formatter-service/0-1
 */
define([
  /* eslint-disable */
  'js/fecha/1.2.2/fecha.min'
  /* eslint-enable */
], function(timeFormatter) {
  'use strict';

  /**
   * This service allows to format date/time and set
   * language for day, year, etc. names.
   * @function
   * @name 'unnamed'
   * @return {Object}
   */
  return function() {
    /**
     * @typedef {Object} language - object which holds names of date/time for different languages
     *
     */
    var language = {
      en: timeFormatter.i18n, // default language
      zh: {
        dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
        dayNames: [
          '星期天',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ],
        monthNamesShort: [
          '一',
          '二',
          '三',
          '四',
          '五',
          '六',
          '七',
          '八',
          '九',
          '十',
          '十一',
          '十二'
        ],
        monthNames: [
          '一月',
          '二月',
          '三月',
          '四月',
          '五月',
          '六月',
          '七月',
          '八月',
          '九月',
          '十月',
          '十一月',
          '十二月'
        ],
        amPm: ['上午', '下午'],
        DoFn: timeFormatter.i18n.DoFn
      }
    };

    return {
      /**
       * Formats date using 'format' pattern, sets language for date/time
       * @function format
       * @param date {Object}   - date to format
       * @param format {String} - date formatting pattern
       * @param lang   {String|Object} - language to use for date naming
       * @return {*}
       */

      format: function(date, format, lang) {
        if (!date || (date && !format) || typeof date === 'string') {
          lang = format;
          format = date;
          date = new Date();
        }

        var previousLanguage = timeFormatter.i18n;
        this.setLanguage(lang);
        var formatted = timeFormatter.format(date, format);
        this.setLanguage(previousLanguage);
        return formatted;
      },
      parse: timeFormatter.parse,
      /**
       * Sets language
       * @function setLanguage
       * @param lang {String|Object} - language to use for date naming
       */

      setLanguage: function(lang) {
        if (typeof lang === 'string') {
          timeFormatter.i18n = language[lang];
        } else if (typeof lang === 'object') {
          timeFormatter.i18n = lang;
        }
      }
    };
  };
});
